export const FETCH_EMPLOYMENTS = 'FETCH_EMPLOYMENTS';
export const FETCH_EMPLOYMENTS_SUCCESS = 'FETCH_EMPLOYMENTS_SUCCESS';
export const FETCH_EMPLOYMENTS_FAILURE = 'FETCH_EMPLOYMENTS_FAILURE';
export const RESET_EMPLOYMENTS = 'RESET_EMPLOYMENTS';

export function fetchEmployments() {

    return {
        type: FETCH_EMPLOYMENTS,
        payload: this.state.employments
    };
}

export function fetchEmploymentsSuccess(employments) {
    return {
        type: FETCH_EMPLOYMENTS_SUCCESS,
        payload: employments
    };
}

export function fetchEmploymentsFailure(error) {
    return {
        type: FETCH_EMPLOYMENTS_FAILURE,
        payload: error
    };
}



/** WEBPACK FOOTER **
 ** ./src/actions/employments.js
 **/